import React from 'react'

const chevron = () => (
  <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.06543 1.06982L7.06543 7.06982L13.0654 1.06982" stroke="#4D4D4F" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export default chevron
